import React from 'react';
import {Link, useLocation} from 'react-router-dom';
import {useAuth} from '../contexts/AuthContext';
import {NavigationLink} from '../types/Navigation';

interface NavigationProps {
  links: NavigationLink[];
}

const Navigation: React.FC<NavigationProps> = ({links}) => {
  const location = useLocation();
  const {user} = useAuth();

  const shouldShowLink = (link: NavigationLink): boolean => {
    if (link.requiresAuth && !user) return false;
    if (link.hideWhenAuth && user) return false;
    if (link.allowedRoles && user && !link.allowedRoles.includes(user.role)) return false;
    return true;
  };

  const getActiveClass = (link: NavigationLink): string => {
    // Handle special cases for active state detection TODO
    // if (link.path === '/about' && (location.pathname === '/' || location.pathname === '/about')) {
    //   return 'active';
    // }
    // if (link.path === '/places' && location.pathname.startsWith('/places')) {
    //   return 'active';
    // }
    // if (link.path === '/organizational-units' && location.pathname.startsWith('/organizational-units')) {
    //   return 'active';
    // }
    // if (location.pathname === link.path) {
    //   return 'active';
    // }
    return '';
  };

  return (
    <nav className="hidden md:flex items-center space-x-6">
      {links.filter(shouldShowLink).map((link) => (
        <span key={link.path} className="text-white hover:text-gray-300 font-medium cursor-pointer">
          <Link
            className={`${getActiveClass(link)}`}
            to={link.path}
          >
            {link.label}
          </Link>
        </span>
      ))}
    </nav>
  );
};

export default Navigation;
